import React, {Component} from 'react';
import {observable, action} from 'mobx';
import {observer} from 'mobx-react';
import m from 'moment';
import {locale_et} from 'lib/locale';

import Event from '../Event';
import Dialog from 'react-toolbox/lib/dialog';
import {RadioGroup, RadioButton} from 'react-toolbox/lib/radio';
import DatePicker from 'react-toolbox/lib/date_picker';
import TimePicker from 'react-toolbox/lib/time_picker';
import Dropdown from 'react-toolbox/lib/dropdown';

@observer
export default class EditEventView extends Component {
  @observable editingTime = false;

  @action toggleEditingTime = () => this.editingTime = !this.editingTime;

  handleToggle = () => {
    this.props.store.toggleEditing();
  };

  handleEventChange = value => {
    this.props.store.editableEvent.setEvent(value);
  };

  handlePersonChange = value => {
    const store = this.props.store;
    console.log('value', value);
    this.props.store.editableEvent.setPersonId(value);
    console.log('selectedPerson', store.editableEvent.personId);
  };

  handleDateChange = date => {
    this.props.store.editableEvent.setTime(date.getTime());
    this.toggleEditingTime();
  };

  handleTimeChange = time => {
    console.log('timechange');
    time.setSeconds(0);
    const t = new Date(this.props.store.editableEvent.time);
    t.setHours(time.getHours());
    t.setMinutes(time.getMinutes());
    t.setSeconds(0);
    this.props.store.editableEvent.setTime(t.getTime());
    this.toggleEditingTime();
  };

  handleCreateNewEvent = () => {
    const event = this.props.store.editableEvent;
    this.props.store.addEventToFB({
      event: event.event,
      personId: event.personId,
      time: Math.floor(event.time / 1000)
    });
    this.handleToggle();
  };

  handleEditEvent = () => {
    const event = this.props.store.editableEvent;
    this.props.store.editEventInFB(event.id, {
      event: event.event,
      personId: event.personId,
      time: Math.floor(event.time / 1000)
    });
    this.handleToggle();
  };

  handleDeleteEvent = () => {
    this.props.store.deleteEventFromFB(this.props.store.editableEvent.id);
    this.handleToggle();
  };

  render() {
    const {store} = this.props;
    const event = store.editableEvent;
    const actions = [
      {label: "Loobu", onClick: this.handleToggle},
      {label: "Lisa", onClick: this.handleCreateNewEvent}
    ];

    if (event.id) {
      actions.push({label: "Muuda", onClick: this.handleEditEvent});
      actions.push({label: "Kustuta", onClick: this.handleDeleteEvent});
    }

    return (
      <Dialog
        actions={actions}
        active={store.editing}
        onEscKeyDown={this.handleToggle}
        onOverlayClick={this.handleToggle}
        title="DIALOGGGG!!"
        type="fullscreen"
      >
        <Dropdown
          auto
          source={store.peopleList}
          onChange={this.handlePersonChange}
          value={store.editableEvent.personId || store.selectedPerson.id}
        />
        <RadioGroup
          value={event.event}
          onChange={this.handleEventChange}
        >
          <RadioButton label="Sisse" value="in"/>
          <RadioButton label="Välja" value="out"/>
        </RadioGroup>
        <DatePicker
          label="Kuupäev"
          value={new Date(event.time)}
          autoOk
          locale={locale_et}
          maxDate={new Date()}
          onChange={this.handleDateChange}
          inputFormat={value => `${m(value).format('LLLL')}`}
        />
        <div hidden>
          <TimePicker
            active={this.editingTime}
            label="Kellaaeg"
            value={new Date(event.time)}
            onChange={this.handleTimeChange}
          />
        </div>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Beeper/Components/EditEventView.js